/* Publish by EComposer at 2026-11-03 17:04:12*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-cpi9bp1f4uu"]=  window.__ectimmers["ecom-cpi9bp1f4uu"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),n=t.querySelector(".text-content.ecom-html");!n||(e&&e.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-cpi9bp1f4uu').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-cpi9bp1f4uu', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-cpi9bp1f4uu', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-boqm85n8mpf').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-boqm85n8mpf', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-boqm85n8mpf', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-67t40c783xh').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-67t40c783xh', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-67t40c783xh', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-ye1msmg6c8h').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-ye1msmg6c8h', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-ye1msmg6c8h', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-q5fp7l4v5ad').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-q5fp7l4v5ad', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-q5fp7l4v5ad', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-rwo8xb0uep').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-rwo8xb0uep', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-rwo8xb0uep', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-b1gqjoxa1ju').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-b1gqjoxa1ju', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-b1gqjoxa1ju', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-0kxr3n91m1qi').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-0kxr3n91m1qi', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-0kxr3n91m1qi', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-glmf6uysp1c').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-glmf6uysp1c', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-glmf6uysp1c', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-w4otk88zk7').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-w4otk88zk7', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-w4otk88zk7', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-uxu331nqw2e').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-uxu331nqw2e', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-uxu331nqw2e', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-2niwu4j8cmh').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-2niwu4j8cmh', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-2niwu4j8cmh', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-za04lm8xkl').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-za04lm8xkl', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-za04lm8xkl', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-vv5gz35mbt').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-vv5gz35mbt', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-vv5gz35mbt', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-jti6ysal61').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-jti6ysal61', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-jti6ysal61', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-9wdalypgexc').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-9wdalypgexc', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-9wdalypgexc', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-x4vdxk4ehb').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-x4vdxk4ehb', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-x4vdxk4ehb', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-u939abonpl').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-u939abonpl', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-u939abonpl', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-zwqrpt7x1wd').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-zwqrpt7x1wd', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-zwqrpt7x1wd', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-om1m2rcun2e').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-om1m2rcun2e', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-om1m2rcun2e', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-xqd34e59b1').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-xqd34e59b1', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-xqd34e59b1', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-86r6il6cawl').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-86r6il6cawl', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-86r6il6cawl', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-834a95k8nhl').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-834a95k8nhl', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-834a95k8nhl', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-vos7rulk0f').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-vos7rulk0f', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-vos7rulk0f', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-rp1xyfktofk').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-rp1xyfktofk', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-rp1xyfktofk', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-afqqgcm0vsn').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-afqqgcm0vsn', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-afqqgcm0vsn', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-9vwi25plwug').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-9vwi25plwug', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-9vwi25plwug', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-gd90vjc1x8r').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-gd90vjc1x8r', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-gd90vjc1x8r', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-t89hvxnc2dk').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-t89hvxnc2dk', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-t89hvxnc2dk', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-yaib0jwp0j').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-yaib0jwp0j', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-yaib0jwp0j', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-ce22wkatkta').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-ce22wkatkta', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-ce22wkatkta', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-hm3rksmcc7m').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-hm3rksmcc7m', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-hm3rksmcc7m', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-sl169glaah').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-sl169glaah', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-sl169glaah', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-x5b99w4ugjq').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-x5b99w4ugjq', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-x5b99w4ugjq', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-eomtjup3z0h').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-eomtjup3z0h', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-eomtjup3z0h', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-0a2fgxuhhqu').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-0a2fgxuhhqu', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-0a2fgxuhhqu', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-zauh8zwvwnn').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-zauh8zwvwnn', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-zauh8zwvwnn', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-p5t44980dxg').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-p5t44980dxg', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-p5t44980dxg', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-7ax5j0r4zfx').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-7ax5j0r4zfx', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-7ax5j0r4zfx', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-hzekjc77jcq').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-hzekjc77jcq', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-hzekjc77jcq', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-9chkclm5pq').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-9chkclm5pq', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-9chkclm5pq', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-jt4tf71ilem').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-jt4tf71ilem', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-jt4tf71ilem', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-gut2ob3d4zi').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-gut2ob3d4zi', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-gut2ob3d4zi', e);
                            }
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-9efd7zxmtvn"]=  window.__ectimmers["ecom-9efd7zxmtvn"] || {};
const t=this.$el;if(!t||!this.isLive)return;const e=t.querySelector(".element__featured--wrapper-list");if(e){let i={top:0,left:0,x:0,y:0};const n=function(r){const a=r.clientX-i.x;e.scrollLeft=i.left-a},o=function(){e.removeEventListener("mousemove",n),e.removeEventListener("mouseup",o),e.style.cursor="default",e.style.removeProperty("user-select")},s=function(r){e.style.cursor="grabbing",e.style.userSelect="none",i={left:e.scrollLeft,top:e.scrollTop,x:r.clientX,y:r.clientY},e.addEventListener("mousemove",n),e.addEventListener("mouseup",o)};e.addEventListener("mousedown",s),e.addEventListener("mouseleave",o)}

                    });
                    
                        document.querySelectorAll('.ecom-9efd7zxmtvn').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-9efd7zxmtvn', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-9efd7zxmtvn', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-wo7c94f4pco').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-wo7c94f4pco', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-wo7c94f4pco', e);
                            }
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-ulwxek4awkn"]=  window.__ectimmers["ecom-ulwxek4awkn"] || {};
const t=function(r){if(window.EComModal)return r();if(window.EComposer&&typeof window.EComposer.loadVendor=="function"){window.EComposer.loadVendor("modal_js").then(function(){window.EComModal&&r()});return}let a=0;const l= window.__ectimmers["ecom-ulwxek4awkn"]["m6g3sjhp8"] = setInterval(function(){window.EComModal?(clearInterval(l),r()):++a>=300&&clearInterval(l)},50)};if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&this.$el){var e=this.$el.querySelector("[ecom-modal]"),i=this.id;t(function(){new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+i]})})}let n=this.$el;if(!n)return;function o(r){const a=r.getBoundingClientRect();return a.top>=0&&a.left>=0&&a.bottom-r.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&a.right<=(window.innerWidth||document.documentElement.clientWidth)}function s(){let r=n.querySelector(".ecom-element.ecom-base-image"),a=n.closest(".core__row--columns");r&&(o(r)?(r.classList.add("image-highlight"),a.setAttribute("style","z-index: unset")):(r.classList.remove("image-highlight"),a.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){s()})

                    });
                    
                        document.querySelectorAll('.ecom-ulwxek4awkn').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-ulwxek4awkn', settings: {"link":"none","lightbox":"no"},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-ulwxek4awkn', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-nmytvrsl36g').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-nmytvrsl36g', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-nmytvrsl36g', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-ayxcwvgjmsc').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-ayxcwvgjmsc', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-ayxcwvgjmsc', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-l5hexzgy6md').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-l5hexzgy6md', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-l5hexzgy6md', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-6r7y0e4wvl8').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-6r7y0e4wvl8', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-6r7y0e4wvl8', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-edm70x6vcar').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-edm70x6vcar', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-edm70x6vcar', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-2j4akrnjcch').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-2j4akrnjcch', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-2j4akrnjcch', e);
                            }
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-qqnkcs6z6x"]=  window.__ectimmers["ecom-qqnkcs6z6x"] || {};
if(!this.$el)return!1;const t=this.$el;this.settings.animation&&function(i){if(!t)return;const n=t.querySelector(".ecom__element--button");if(!n)return;let o=parseInt(i.settings.animation_loop_time)*1e3||6e3,s=1e3;window.__ectimmers["ecom-qqnkcs6z6x"]["0gvsunfty"] = setInterval(function(){n.classList.add("animated"),setTimeout(function(){n.classList.remove("animated")},s)},o)}(this);var e=t.querySelector(".ecom__element--button");this.isLive&&e&&e.dataset.ecTrackingId&&e.addEventListener("click",function(i){if(window.Shopify&&window.Shopify.analytics){i.preventDefault();let n=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const o=Object.assign({button_id:e.id,tracking_id:e.dataset.ecTrackingId},n);try{Shopify.analytics.publish("ec_custom_events",o)}catch(a){console.error("[EC Tracking] Error publishing analytics event:",a)}const s=e.getAttribute("href"),r=e.getAttribute("target");s&&s!=="#"&&s!=="javascript:void(0)"&&(r==="_blank"?window.open(s,"_blank"):setTimeout(function(){window.location.href=s},300))}},{once:!0}),this.isLive&&e&&e.dataset.eventTrackingFb&&e.addEventListener("click",function(i){window.fbq&&window.fbq("track",`${e.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-qqnkcs6z6x').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-qqnkcs6z6x', settings: {"animation":false},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-qqnkcs6z6x', e);
                            }
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-875ouu89rot"]=  window.__ectimmers["ecom-875ouu89rot"] || {};
var $,E,I,j,M,D;let t=this.$el;if(!t)return;let e=this.isLive;const i=($=this.settings.disable_auto_close)!=null?$:!1,n=(E=this.settings.disable_auto_close__tablet)!=null?E:!1,o=(I=this.settings.disable_auto_close__mobile)!=null?I:!1,s=(j=this.settings.scroll_on_mobile)!=null?j:!1,r=(M=this.settings.disable_effect)!=null?M:!1,a=(D=this.settings.close_all)!=null?D:!1,l=t.querySelector(":scope > .core__group--wrapper > .core__group--items"),c=l?l.querySelectorAll(":scope > .ecom-accordion__item"):[],d=Array.from(c).map(T=>T.querySelector(":scope > .ecom-accordion__title")).filter(Boolean);function p(T){const F=T.getBoundingClientRect();return F.top>=0&&F.left>=0&&F.bottom<=(window.innerHeight||document.documentElement.clientHeight)&&F.right<=(window.innerWidth||document.documentElement.clientWidth)}function m(){return window.EComposer.TEMPLATE_ID?window.screen.width:window.innerWidth}function _(T){return o&&T<768||n&&T>767&&T<1025||i&&T>1024}function b(T){if(!T)return;const F=T.style.transition;T.style.transition="none",T.style.height="auto";const H=T.scrollHeight;T.style.height="0px",T.offsetHeight,T.style.transition=F,requestAnimationFrame(()=>{const R=r?"auto":e?H+"px":"auto";T.style.height=R})}function y(T){T.classList.remove("ecom-item-active");const F=T.querySelector(":scope > .ecom-accordion__body");F&&(r||(F.style.height=F.scrollHeight+"px",F.offsetHeight),requestAnimationFrame(()=>{F.style.height="0px"}))}function v(T){let F=0;if(T.offsetParent)do F+=T.offsetTop;while(T=T.offsetParent);return F}function w(T){const F=Math.max(0,T),H=window.pageYOffset||document.documentElement.scrollTop,R=F-H;if(R===0)return;const K=300;let W=null;function G(se){W||(W=se);const te=Math.min((se-W)/K,1),Y=te<.5?2*te*te:1-Math.pow(-2*te+2,2)/2;window.scrollTo(0,H+R*Y),te<1&&window.requestAnimationFrame(G)}window.requestAnimationFrame(G)}function S(T){w(v(T)-100)}function C(T,F=!1){T.forEach((H,R)=>{const K=H.parentNode,W=K.querySelector(":scope > .ecom-accordion__body");!r&&W&&W.classList.add("ecom-effect-accodion");const G=K.classList.contains("ecom-item-active");W&&!a&&(F&&R===0||G)&&requestAnimationFrame(()=>{W.style.height=W.scrollHeight+"px"}),H.onclick=function(se){var ue,_e;if(se.preventDefault(),!e){window.dispatchEvent(new window.Event("renderScroll"));return}const te=m(),Y=this.parentNode,pe=Y.parentNode,de=pe.querySelectorAll(":scope > .ecom-accordion__item"),he=Array.from(de).map(we=>we.querySelector(":scope > .ecom-accordion__title")).filter(Boolean),J=Y.querySelector(":scope > .ecom-accordion__body");Y.classList&&Y.classList.remove("ecom-item-group-init");const V=this.classList.contains("ecom-item-active"),X=_(te);if(V)X?(this.classList.remove("ecom-item-active"),Y.classList.remove("ecom-item-active"),y(Y)):(de.forEach(y),he.forEach(we=>we.classList.remove("ecom-item-active")));else{X||(de.forEach(y),he.forEach(Ae=>Ae.classList.remove("ecom-item-active"))),H.classList.add("ecom-item-active"),Y.classList.add("ecom-item-active");let we=Y.closest(".ecom-accordion__body");for(;we;)we.style.height="auto",we=(_e=(ue=we.parentElement)==null?void 0:ue.closest)==null?void 0:_e.call(ue,".ecom-accordion__body");!r&&J&&J.classList.add("ecom-effect-accodion"),b(J)}window.dispatchEvent(new window.Event("renderScroll"));const Q=this,ge=s||te>1024;function ee(){window.dispatchEvent(new window.Event("renderScroll")),ge&&!p(Q)&&S(Q)}if(ge&&!r){let we;const Ae=function(Ee){Ee.propertyName==="height"&&(clearTimeout(we),we=setTimeout(()=>{pe.removeEventListener("transitionend",Ae),ee()},50))};pe.addEventListener("transitionend",Ae),setTimeout(()=>{pe.removeEventListener("transitionend",Ae),ee()},600)}else requestAnimationFrame(()=>{setTimeout(ee,100)})}})}C(d,!0),a||requestAnimationFrame(()=>{const T=t.querySelector(".ecom-item-group-init");T&&T.classList.remove("ecom-item-group-init")});function x(){const T=window.location.hash;if(T){const F=t.querySelector(`[data-target="${T}"]`);if(F){F.click(),F.dispatchEvent(new MouseEvent("mouseover",{bubbles:!0,cancelable:!0,view:window}));const K=F.getBoundingClientRect().top+window.pageYOffset-window.innerHeight/2;w(K)}}}requestAnimationFrame(()=>{setTimeout(x,100)}),window.addEventListener("resize",()=>C(d)),window.addEventListener("hashchange",x,!1)

                    });
                    
                        document.querySelectorAll('.ecom-875ouu89rot').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-875ouu89rot', settings: {"disable_auto_close":false,"disable_effect":false,"close_all":false},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-875ouu89rot', e);
                            }
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-130gp6qownle"]=  window.__ectimmers["ecom-130gp6qownle"] || {};
if(!this.$el)return!1;const t=this.$el;let e=t.closest(".ecom-product-form--single");if(!e){const n=t.closest(".ecom-builder");n&&(e=n.querySelector(".ecom-product-form--single"))}if(!e)return!1;if(this.isLive){let n=e.querySelector("[name=id]");const s=(n?parseInt(n.getAttribute("ec-variants")):0)>250||e.querySelector("[data-high-variant-product]"),r=t.querySelector(".ecom-product-single__buy_it_now_btn--checkout"),a=e.dataset.product_id;if(!a)return;let l=null;const c=e.querySelector("[id^=product-json-"+a+"]");if(!c)return;try{l=JSON.parse(c.innerHTML)}catch(d){return}r&&r.addEventListener("click",function(d){d.preventDefault();let p=1;e.querySelector("[name=quantity]")&&(p=e.querySelector("[name=quantity]").value);let m=e.querySelector("select[name=id]")||e.querySelector("input[name=id]");m||console.warn("EC error: Select id or input id not found!");let _=m.value,b=null;if(s?b=l:b=l.variants.find(v=>v.id==_),!b||b.available===!1)return;window.Shopify.analytics&&Shopify.analytics.publish("ec_buy_now",{cartLine:{cost:{totalAmount:{amount:b.price*p,currencyCode:window.Shopify.currency.active}},merchandise:{id:b.id,image:b.image,price:{amount:b.price,currencyCode:window.Shopify.currency.active},product:{id:l.id,title:l.title,vendor:l.vendor},sku:b.sku,title:b.title},quantity:p}});let y=`${window.EComposer.routes.cart_url}/${_}:${p}`;if(window.location.search.includes("selling_plan")){const v=/selling_plan=(\d+)/,w=window.location.search.match(v);if(w){const S=w[1];y=`${window.EComposer.routes.cart_url}/clear?return_to=/cart/add?items[][id]=${_}%26items[][quantity]=${p}%26items[][selling_plan]=${S}%26return_to=/checkout`}}location.href=y}),l.available||(r.classList.add("ecom-disable-buy"),r.disabled=!0),n&&e.addEventListener("ecomVariantChange",function(d){let p=d.detail.variant;!p||p.available===!1?(r.classList.add("ecom-disable-buy"),r.disabled=!0):(r.classList.remove("ecom-disable-buy"),r.disabled=!1)})}const i=function(n){if(!t)return;const o=t.querySelector(".ecom-product-single__buy_it_now_btn--checkout");if(!o)return;let s=parseInt(n.settings.animation_loop_time)*1e3||6e3,r=1e3;window.__ectimmers["ecom-130gp6qownle"]["rfvbzbjfm"] = setInterval(function(){o.classList.add("animated"),setTimeout(function(){o.classList.remove("animated")},r)},s)};this.settings.animation&&i(this)

                    });
                    
                        document.querySelectorAll('.ecom-130gp6qownle').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-130gp6qownle', settings: {"animation":true},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-130gp6qownle', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-5eux2kowjp6').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-5eux2kowjp6', settings: {"animation":true},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-5eux2kowjp6', e);
                            }
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}